(function($) {
    // // Fittext
    // $(".fit").fitText(0.1, { minFontSize: '20px', maxFontSize: '400px' });

    // Hamburger menu
    $('.menu-toggle').on('click touchstart', function(e) {
        $('body').toggleClass('menu-open');
        $('html').toggleClass('no-scroll');
        $('.hamburger-button').toggleClass('is-active');
        e.preventDefault();
    });

    // Search toggle mobile
    $('.search-toggle').on('click touchstart', function(e) {
        $('.search-form').addClass('show animate');
        $('html').addClass('no-scroll');
        $('.search-toggle').addClass('is-active');
        e.preventDefault();
    });

    // Search toggle mobile
    $('.searchform-close').on('click touchstart', function(e) {
        $('.search-form').removeClass('show animate');
        $('html').removeClass('no-scroll');
        $('.search-toggle').removeClass('is-active');
        e.preventDefault();
    });

      // Responsive navigation
	$( '.nav .sub-menu' ).before( '<button class="sub-menu-toggle" role="button" aria-pressed="false"></button>' );
	// Show / hide the navigation
	$( '.sub-menu-toggle' ).on( 'click', function() {
		var $this = $( this );
		$this.attr( 'aria-pressed', function( index, value ) {
		return 'false' === value ? 'true' : 'false';
	});
		$this.toggleClass( 'active' );
		$this.next( '.sub-menu' ).slideToggle(  '600' );
	});

    $(".slide-link a").click(function(e) {
        e.preventDefault();
        var offset = -100;
        var aid = $(this).attr("href");
        $('html,body').animate({scrollTop: $(aid).offset().top + offset},'slow');
      });

	// Toggle subpages

	if( $(".toggle .toggle-title").hasClass('active') ){
			$(".toggle .toggle-title.active").closest('.toggle').find('.toggle-inner').show();
		}
		$(".toggle .toggle-title").click(function(){
			if( $(this).hasClass('active') ){
				$(this).removeClass("active").closest('.toggle').find('.toggle-inner').slideUp(200);
			}
			else{	$(this).addClass("active").closest('.toggle').find('.toggle-inner').slideDown(200);
		}
	});
	

})(jQuery);